jQuery(document).ready(function ($) {

    $('[data-open-help-modal]').on('click', function(){
        $('.helpMenu').show();
        $('.helpMenu').addClass('is-open');
    });

    $('.beforeAfter__mobileSelect').prop('selectedIndex', 0).trigger('change');

    $('.pdpMain__image').each(function(){
        if ($(this).attr('src') == ''){
            $(this).closest('.pdpMain__imageBlock').hide();
        }
    });

    $('a[href^="#"]').on('click', function(e) {
        e.preventDefault();

        var target = $(this.getAttribute('href'));

        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 600); // duration in ms
        }
    });

    $('.collectionCard .colorCircle').on('click', function(){
        if ($(this).attr("data-swap-image") != ""){
            var swapImage = $(this).attr("data-swap-image");
            $(this).closest('.collectionCard').find('.collectionCard__image').attr('src', swapImage);
        }
    });

    

    (function(){
        const scroller = document.querySelector('.pdpMain__imageSide');
        const track = document.querySelector('.pdpMain__scrollbarOuter');
        const thumb = document.querySelector('.pdpMain__scrollbarInner');

        if (!scroller || !track || !thumb) return;

        let rafId = null;

        function update(){
            rafId = null;

            const scrollWidth = scroller.scrollWidth;
            const clientWidth = scroller.clientWidth;
            const maxScroll = scrollWidth - clientWidth;

            // If it doesn't actually scroll, hide the track
            if (maxScroll <= 1){
            track.style.display = 'none';
            return;
            } else {
            track.style.display = '';
            }

            const trackWidth = track.clientWidth;

            // Thumb width = visible fraction (like a real scrollbar)
            const visibleRatio = clientWidth / scrollWidth;
            const thumbWidth = Math.max(24, Math.round(trackWidth * visibleRatio)); // min size so it stays usable/visible
            thumb.style.width = thumbWidth + 'px';

            // Thumb travel range
            const maxThumbX = trackWidth - thumbWidth;

            // Current progress
            const progress = scroller.scrollLeft / maxScroll;
            const thumbX = Math.round(maxThumbX * progress);

            thumb.style.transform = `translateX(${thumbX}px)`;
        }

        function scheduleUpdate(){
            if (rafId) return;
            rafId = requestAnimationFrame(update);
        }

        // Events
        scroller.addEventListener('scroll', scheduleUpdate, {passive:true});
        window.addEventListener('resize', scheduleUpdate);

        // If images load after JS runs, widths change—update again on load
        window.addEventListener('load', scheduleUpdate);

        // If your PDP swaps images/variants dynamically, this catches layout changes
        const ro = new ResizeObserver(scheduleUpdate);
        ro.observe(scroller);
        const inner = scroller.querySelector('.pdpMain__imageSideInner');
        if (inner) ro.observe(inner);

        // Initial
        update();
    })();

    var initialChange = 0;
    var newsletterListener = setInterval(function(){
        if ($('.kl-teaser-UA2kpp button[aria-label="Close teaser"]').length > 0){
            if ($('.helpButton').hasClass('helpButton--low')){
                $('.helpButton').removeClass('helpButton--low');
                if (initialChange == 0){
                    initialChange = 1;
                }
            }
        }
        else{
            if ($('.helpButton').hasClass('helpButton--low') == false){
                $('.helpButton').addClass('helpButton--low');
                if (initialChange == 1){
                    clearInterval(newsletterListener);
                }
            }
        }
    }, 100);

    $('.headerSearch__submit').on('click', function(){
        var searchString = $('.headerSearch__input').val();
        window.location.href = "/search?q=" + encodeURIComponent(searchString);
    });

    $('.headerSearch__input').on('keydown', function(e) {
        if (e.key === 'Enter') {
            e.preventDefault();

            var searchString = $(this).val();

            if (searchString && searchString.trim() !== '') {
                window.location.href = "/search?q=" + encodeURIComponent(searchString);
            }
        }
    });

    $('.header__funcButtonWrapper--search > button').on('click', function(){
        if ($('.headerSearch').is(':visible')){
            $('.headerSearch').slideUp();
        }
        else{
            $('.headerSearch').slideDown();
        }
    });
    
});